import { useEffect, useState, Fragment } from 'react';
import axios from 'axios';
import Header from './Header';
import DefaultSidebar from './Sidebar'
// import ListToggle from './ListToggle';
import { Card } from "@material-tailwind/react";
import ModalModifyTizenbo from "./ModalModifyTizenbo"
import { Link } from 'react-router-dom';


function ListProgramme() {
    const [data, setDate] = useState([])
    const [search, setSearch] = useState('');
    // const [open, setOpen] = useState('block');
    const [sortedBy, setSortedBy] = useState()
    const [counter, setCounter] = useState(0)
    // const [showModalModify, setShowModalModify] = useState(false);
    // const [isSmallScreen, setIsSmallScreen] = useState(false);

    // const [choosenClientBo, setChoosenClientBo] = useState({
    //     _mac_eth: '',
    //     _tizen_id: '',
    //     _pin_code: '',
    //     _client_name: '',
    //     _app_type: '',
    //     _authorized: '',
    //     _video_url: '',
    //     _video_url_2: '',
    //     _video_url_3: '',
    //     _video_code: '',
    //     _video_code_2: '',
    //     _video_code_3: '',
    //     _end_date:'',
    //     id:'',
    //     _app_version:'',
    //     _zoom:'',
    //     _display_id:'',
    //     _client_id:'',
    //     _room_id:'',
    //     _id_pdv:''
    // });

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/InterfaceTizenDevice`)
            .then(res => {
                console.log(res.data);
                setDate(res.data)
            }).catch(err => console.log(err))
    }, [])

    const TABLE_HEAD = [
        { key: "_client_name", text: "Nom Client" },
        { key: "_app_type", text: "Type d'app" },
        { key: "_pin_code", text: "Code PIN" },
    ];


    const sorted = data.sort((a, b) => {

        const aVal = a[sortedBy];
        const bVal = b[sortedBy];
        if (typeof aVal === "number" && typeof bVal === "number") {
            if (counter % 2 === 0) return aVal - bVal;
            else return bVal - aVal;
        }
        else if (typeof aVal === "string" && typeof bVal === "string") {
            if (counter % 2 === 0) return aVal.localeCompare(bVal);
            else return bVal.localeCompare(aVal);
        }
        return 1;
    });

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    const ListTable = (() => {
        return (
            <Card className="w-full overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
                <div className="overflow-x-auto">
                    <table className="w-full min-w-max table-auto text-left">
                        <thead className="border-b border-slate-200 bg-slate-50">
                            <tr className='sticky top-0'>
                                {TABLE_HEAD.map((head) => (
                                    <th
                                        key={head.key}
                                        className="cursor-pointer whitespace-nowrap px-4 py-3 text-xs font-semibold uppercase tracking-wide text-slate-500 hover:text-slate-700"
                                        onClick={() => { setSortedBy(head.key); setCounter(counter + 1) }}
                                    >
                                        <span className="inline-flex items-center gap-1">
                                            {head.text}
                                            {sortedBy === head.key && (
                                                <span className="text-indigo-500">
                                                    {counter % 2 === 0 ? "▲" : "▼"}
                                                </span>
                                            )}
                                        </span>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {sorted.filter((item) => {
                                return search.toLowerCase() === ''
                                    ? item
                                    : item._client_name.toLowerCase().includes(search.toLowerCase()) || item._pin_code.toLowerCase().includes(search.toLowerCase())
                            }).map((data, index) => {
                                const isLast = index === data.length - 1;
                                const classes = isLast
                                    ? "whitespace-nowrap px-4 py-3 text-sm text-slate-700"
                                    : "whitespace-nowrap px-4 py-3 text-sm text-slate-700";

                                return (
                                    <tr key={data.id} className="cursor-pointer border-b border-slate-100 transition-colors hover:bg-indigo-50/40">
                                        <td className={classes}>
                                            <Link to={`/programme/${data._pin_code}`}
                                                state={{ clientName: data._client_name }}
                                                className="block font-medium text-slate-800"
                                            >
                                                {data._client_name}
                                            </Link>
                                        </td>
                                        <td className={classes}>
                                            <Link to={`/programme/${data._pin_code}`}
                                                state={{ clientName: data._client_name }}
                                                className="block"
                                            >
                                                {data._app_type}
                                            </Link>
                                        </td>
                                        <td className={classes}>
                                            <Link to={`/programme/${data._pin_code}`}
                                                state={{ clientName: data._client_name }}
                                                className="block"
                                            >
                                                {data._pin_code}
                                            </Link>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </Card>
        );
    })
    return (
        <Fragment>
            <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6">
                {/* <Header /> */}
                <div className="mb-4">
                    <h1 className="text-xl font-semibold text-slate-800">Programmes</h1>
                    <p className="text-sm text-slate-500">Liste des clients et de leurs programmes</p>
                </div>
                <div className="mb-4 max-w-md">
                    {/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 absolute left-1 cursor-pointer" onClick={() => setOpen(open === `hidden` ? 'block' : 'hidden')} >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                    </svg> */}
                    {/* <ListToggle /> */}
                    <div className="relative flex h-10 items-center rounded-xl border border-slate-200 bg-white shadow-sm focus-within:border-indigo-500 focus-within:ring-2 focus-within:ring-indigo-500/20">
                        <svg xmlns="http://www.w3.org/2000/svg" className="ml-3 h-5 w-5 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>

                        <input
                            className="h-full w-full rounded-xl bg-transparent px-3 text-sm text-slate-800 placeholder-slate-400 outline-none"
                            type="text"
                            id="search"
                            placeholder="Rechercher un client, un code PIN..."
                            onChange={(e) => setSearch(e.target.value)} />
                    </div>
                </div>
                <main className="mt-4">
                    {/* <DefaultSidebar isOpen={open} /> */}
                    {ListTable()}
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10 fixed bottom-6 right-6	cursor-pointer text-slate-400 hover:text-slate-600" onClick={() => scrollToTop()}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15 11.25l-3-3m0 0l-3 3m3-3v7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </main>
            </div>
            {/* <ModalModifyTizenbo isVisible={showModalModify} onClose={() => setShowModalModify(false)} choosenClientBo={choosenClientBo} /> */}
        </Fragment>

    );
}
export default ListProgramme;